import cn from 'classnames'
import { theme } from '../../styles/theme'
import { createUseStyles } from '../../helpers/createStyles'
import gsap from 'gsap'
import { useEffect, useRef } from 'react'

export default function Overlay ({ show, onClick, hideAtDesktop, zIndex }) {
  const styles = useStyles()
  const ref = useRef()
  useEffect(() => {
    gsap.to(ref.current, { opacity: show ? 0.4 : 0, pointerEvents: show ? 'all' : 'none', duration: 0.5, ease: 'sine.inOut' })
  }, [show])
  return (
    <div className={cn(styles.overlay, { hideAtDesktop })} onClick={onClick} ref={ref} style={{ zIndex }} />
  )
}

const useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    backgroundColor: theme.colors.black,
    zIndex: theme.zIndex.dialog,
    pointerEvents: 'none',
    opacity: 0,
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      height: '100vh'
    },
    '&.hideAtDesktop': {
      display: 'block',
      [theme.breakpoints.up('md')]: {
        display: 'none'
      }
    }
  }
})
